module.exports = __webpack_public_path__ + "img/standard-clean3.e9fd3ba2.jpg";